import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5060Service } from '../../CSPService/CSP5060/csp5060.service';
import { Csp5060Class } from '../../CSPClass/CSP5060/csp5060-class';

@Component({
  selector: 'kt-csp5060-view',
  templateUrl: './csp5060-view.component.html',
  styleUrls: ['./csp5060-view.component.scss']
})
export class Csp5060ViewComponent implements OnInit {

   lblPageTitle: string = "";
    HolidayList: any[] = [];
  
 


  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5060ViewComponent>, private objCsp5060Service:Csp5060Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.onGetDatas();
  }

   onGetDatas() {
             if (localStorage.getItem('currentUser') != null) {
                this.objCsp5060Service.HolidayList().subscribe((data) => {           
                this.HolidayList = data.HolidayList;
              });
              this.changeDetectorRef.detectChanges();
            }
          }
  onClose() {


  if (this.dialogRef) {
    this.dialogRef.close();
  }
}


   getComponentTitle() {
    let result =  "Holiday List";
    return result;
   }
}
